import React from "react";
import sampleImage from '../../assets/images/001.jpg';
import { useTranslation } from 'react-i18next';

const Favorites = () => {
    const { t } = useTranslation();
    return(
        <>
            <div className="col-md-12 col-lg-12 mt-md-4 mt-sm-0 inner-page-heading-wrapper">
                <button className="win-back-btn"><span><i className='bi bi-chevron-left'></i> {t('back')}</span></button>
                <h2 className="page-heading">{t('favourites')}</h2>
            </div>

            <div className="col-md-12 mt-5">
                <div className="favorites-wrapper">
                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a Appoi ntment sch eduled asdf sdf dasdf    */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon favsaved"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>

                    <div className="favorites-details-wrapper">
                        <div className="favorites-pharmasy-name">
                            {/* You have a  Appointment scheduled      */}
                            <img src={sampleImage} alt="" className="favorites-pharmasy-logo" />                           
                        </div>
                        <div className="favorites-icon"></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Favorites;